export const getEmailDomain = (email: string): string => {
  const parts = email.split("@");
  const domain = parts[1] ?? "";
  return domain.toLocaleLowerCase().trim();
};
